<template>
  <section class="formItemBox">
    <span
      class="primary cur billBtn"
      v-show="listData.length === 0"
      @click="add(0)"
      >添加路桥费</span
    >
    <qx-card-form
      :title="'路桥费' + (index + 1)"
      v-for="(item, index) in listData"
      :key="index"
    >
      <span slot="titleLeft">
        <template v-if="item.id">
          <span style="margin-left: 16px">
            <span
              :class="{
                'warning-bg': item.state === 0,
                'primary-bg': item.state === 3,
                'error-bg': item.state === 4,
                'success-bg': item.state === 5,
              }"
              style="color: #fff; padding: 3px"
              >{{ item.stateName }}</span
            >
          </span>
        </template>
        <span
          class="primary cur btn"
          @click="add(index)"
          v-show="index === listData.length - 1"
          >添加</span
        >
        <span
          class="error cur btn"
          @click="del(index)"
          v-show="!item.id && listData.length !== 1"
          >删除</span
        >
        <template v-if="item.paymentWay === 2">
          <span class="btn">现金过路费用上报</span>
          <span class="btn error"
            >此部分费用审核通过后自动生成车辆费用申请记录，请不要重复申报。</span
          >
        </template>
        <!-- <template v-else>
          <span class="btn">公司油卡加油费用上报</span>
          <span class="btn error"
            >此部分费用只做记录，不能报销；对于扫码加油的记录，不用在这里登记。</span
          >
        </template> -->
      </span>
      <FormBox
        ref="formBox"
        :initData="item"
        @handlePaymentWayChange="
          (paymentWay) => handlePaymentWayChange(paymentWay, index)
        "
      />
    </qx-card-form>
    <!-- <button @click="sub">测试</button> -->
  </section>
</template>

<script>
import FormBox from './formBox';
export default {
  components: {
    FormBox,
  },
  data () {
    return {
      listData: [],

      etcCardNum: '',
    };
  },
  methods: {
    handlePaymentWayChange (paymentWay, index) {
      this.listData[index].paymentWay = paymentWay;
    },
    setFormState () {
      if (this.listData && this.listData.length) {
        for (let i = 0; i < this.listData.length; i++) {
          const item = this.listData[i];
          const formBox = this.$refs.formBox[i];
          formBox.setDisabledByState(false);
          formBox.setRequiredByState(true);
          if (item.state === 3 || item.state === 5) {
            if (item.id) {
              // 有 id 证明是详情接口返回的数据，要根据状态判断是否可修改
              formBox.setDisabledByState(true);
              formBox.setRequiredByState(false);
              // 已绑定卡
              if (this.etcCardNum) {
                formBox.$refs.baseForm.setVal('cardNo', this.etcCardNum);
              }
              formBox.$refs.baseForm.setVal('state', item.state);
              formBox.$refs.baseForm.setVal('stateName', item.stateName);
            }
          }
          formBox.handlePaymentWayChange();
        }

      }
    },
    add (index) {
      this.listData.splice(index + 1, 0, {
        amount: '',
        paymentWay: 3,
        subTime: '',
        cardNo: '',
        file: [],
        remark: '',
        id: 0,
        // id: Symbol('item'),
      });
    },
    del (index) {
      this.listData.splice(index, 1);
    },
    async handleSubData (cache) {
      let result = [];
      for (let i = 0; i < this.$refs.formBox.length; i++) {
        let formData;
        if (cache) {
          formData = await this.$refs.formBox[i].getVal();
        } else {
          formData = await this.$refs.formBox[i].sub();
        }
        if (!formData) {
          return null;
        } else {
          formData.subTime = this.formatDate(formData.subTime, 1);
          formData.file.forEach((item, index) => {
            formData[`fileId${index || ''}`] = item.id;
            formData[`fileUrl${index || ''}`] = item.url;
            formData[`fileUrl${index || ''}Path`] = item.url;
          });
          delete formData.file;
          result.push(formData);
        }
      }
      return {
        etcCostDataList: result,
      };
    },

    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      if (res) {
        res.etcCostDataListStr = JSON.stringify(res.etcCostDataList);
        delete res.etcCostDataList;
        delete res.oilCostDataList;
        delete res.logs;
        delete res.otherCostDataList;
      }
      return res;
    },
    init (data = {}) {
      if (!data.etcCostDataList || data.etcCostDataList.length === 0) {
        this.listData = [{
          amount: '',
          paymentWay: 3,
          cardNo: '',
          file: [],
          remark: '',
          id: 0,
          // id: Symbol('item'),
        }];
      } else {
        this.listData = data.etcCostDataList.map((item) => {
          let file = [];
          Object.keys(item).forEach((key) => {
            if (key.indexOf('fileId') !== -1) {
              const fileIndex = key.substr(6) || '';
              if (item[`fileId${fileIndex}`]) {
                file.push({
                  id: item[`fileId${fileIndex}`],
                  url: item[`fileUrl${fileIndex}Path`],
                });
              }
            }
          });
          return {
            ...item,
            file,
          };
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.formItemBox {
  padding-left: 24px;
}
.btn {
  margin-left: 16px;
}
</style>
